module.exports = __webpack_public_path__ + "img/product_112.3b3d889.svg";